import { Dropdown } from "react-bootstrap";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import SvgCornerUpLeft from "components/svg/SvgCornerUpLeft";
import SvgEdit3 from "components/svg/SvgEdit3";
import useReversalProduct from "../../hooks/hookReversalProduct";
import useChangePriceSale from "../../hooks/hookChangePriceSale";
import * as apiWarehouse from "api/apiWarehouses";
import { useObjectCard } from "../../context/ObjectCardProvider";
import { useToast } from "context/ToastContext";
import SvgEye from "components/svg/SvgEye";
import vconst from "utils/helpers/structs/vconst";
import { useEffect, useState } from "react";
import SolarIcon from 'components/icons/SolarIcon';

const ObjectProductActions = ({operation, setShowSpinnerProducts, showOperationInfo, setShowOperationInfo}) => {
 
    const { t } = useTranslation(['Objects']);
    const { reversalProduct } = useReversalProduct();
    const { changePriceSale } = useChangePriceSale();
    const { showToast } = useToast();
    const { vObject, fetchObject, isEditLocked } = useObjectCard();
    const [ disableActions, setDisableActions ] = useState(false);

    const handleReversalProduct = async () => {
        setShowSpinnerProducts(true)
        const resReversal = await apiWarehouse.reversalOperation(operation.ID);
        await fetchObject();
        setShowSpinnerProducts(false);
        if (resReversal) showToast(t('messReversaled'), 'success');
            else showToast(t('common:messError'), 'danger');
    }
 
    const handleChangePriceSale = async ({price, priceSale})=>{
        setShowSpinnerProducts(true)        
        const priceData = { priceSale, price }
        const resChangePrice = await apiWarehouse.setPriceSale(operation.ID, priceData);
        await fetchObject();    
        setShowSpinnerProducts(false);
        if (resChangePrice) showToast(t('messPriceChanged'), 'success');
            else showToast(t('common:messError'), 'danger');

    } 

    useEffect(()=>{
        const status = vObject?.object?.objectStatus;
        const statusOk =
            [vconst.objectPanding, vconst.objectInWork].includes(status) ||
            (status === vconst.objectFinished && !isEditLocked);
        setDisableActions(
            operation.operStatus !== vconst.operStatApproved || !statusOk
        )
    },[operation, vObject, isEditLocked])

    const renderMenuItem = (icon, title, subtitle, onSelect, options) => (
        <Dropdown.Item
            as="button"
            disabled={options?.disabled}
            className={options?.danger ? 'text-danger' : undefined}
            onClick={(e) => {
                onSelect();
                e.currentTarget.blur();
            }}
        >
            <div className="d-flex align-items-start w-100 text-start">
                <span
                    className={`d-inline-flex align-items-center justify-content-center flex-shrink-0 me-2 item-icon${
                        options?.danger ? ' text-danger' : ''
                    }`}
                >
                    {icon}
                </span>
                <div className="flex-grow-1 min-w-0">
                    <div className={`fw-medium ${options?.danger ? 'text-danger' : ''}`}>{title}</div>
                    <small className="text-muted warehouse-team-menu-hint">{subtitle}</small>
                </div>
            </div>
        </Dropdown.Item>
    );

    const menu = (
        <Dropdown.Menu
            className="p-2 shadow-sm warehouse-team-menu"
            popperConfig={{ strategy: 'fixed' }}
            renderOnMount
        >
            {renderMenuItem(
                <SvgEye />,
                t('productPopup.info'),
                t('productPopup.infoHint'),
                () => setShowOperationInfo(operation.ID),
            )}

            <Dropdown.Divider className="my-2" />

            {renderMenuItem(
                <SvgCornerUpLeft />,
                t('productPopup.reversal'),
                t('productPopup.reversalHint'),
                () => reversalProduct(handleReversalProduct),
                { disabled: disableActions },
            )}

            {renderMenuItem(
                <SvgEdit3 />,
                t('productPopup.editPrice'),
                t('productPopup.editPriceHint'),
                () => changePriceSale({
                    priceSale: operation.operPriceSale,
                    price: operation.operPrice,
                }, handleChangePriceSale),
                { disabled: disableActions },
            )}
        </Dropdown.Menu>
    );

    return (
        <Dropdown align="end">
            <Dropdown.Toggle className="p-1 py-0" 
                size="sm" 
                variant="light-secondary" 
                id="dropdown-basic">
                <SolarIcon name="three-dots" />
            </Dropdown.Toggle>

            {typeof document !== 'undefined' ? createPortal(menu, document.body) : menu}
        </Dropdown>
    );
}

export default ObjectProductActions;
